module.exports = __webpack_public_path__ + "img/statement-icon.9e37bda4.png";